import { render, staticRenderFns } from "./shenheStock.vue?vue&type=template&id=4828d608&scoped=true&"
import script from "./shenheStock.vue?vue&type=script&lang=js&"
export * from "./shenheStock.vue?vue&type=script&lang=js&"
import style0 from "./shenheStock.vue?vue&type=style&index=0&id=4828d608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828d608",
  null
  
)

export default component.exports